import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { gql, useMutation } from '@apollo/client';
import { getClient } from '../client';
export var CREATE_USER_MANUAL_INPUT = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation CreateUserManualInput(\n    $entityType: EntityType!\n    $phraseContent: String!\n  ) {\n    createUserManualInput(\n      entityType: $entityType\n      phraseContent: $phraseContent\n    )\n  }\n"])));
export var UPDATE_USER_MANUAL_INPUT = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  mutation UpdateUserManualInput(\n    $phraseUuid: UUID!\n    $phraseContent: String\n    $status: Status\n  ) {\n    updateUserManualInput(\n      phraseUuid: $phraseUuid\n      phraseContent: $phraseContent\n      status: $status\n    )\n  }\n"])));
/**
 * Create manual user input
 * @returns Mutation Tuple
 */

export var useCreateUserManualInput = function useCreateUserManualInput() {
  var client = getClient();
  return useMutation(CREATE_USER_MANUAL_INPUT, process.env.JEST_WORKER_ID === undefined ?
  /* istanbul ignore next */
  {
    client: client
  } : {});
};
/**
 * Update manual user input
 * @returns Mutation Tuple
 */

export var useUpdateUserManualInput = function useUpdateUserManualInput() {
  var client = getClient();
  return useMutation(UPDATE_USER_MANUAL_INPUT, process.env.JEST_WORKER_ID === undefined ?
  /* istanbul ignore next */
  {
    client: client
  } : {});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-plat-ui/utils/dist/esm/hooks/userManualInput.js
// module id = 5772
// module chunks = 11